/* import __COLOCATED_TEMPLATE__ from './specifications-response.hbs'; */
import Component from '@glimmer/component';
import FilterConstants from '../../filter-constants';
import SpecificationResult from 'filter-wizard/models/results/specification';

const Position = { LEFT: 'Left', CENTER: 'Center', RIGHT: 'Right' };

interface SpecResponseArgs {
  geometry: { width: number; height: number };
  model: SpecificationResult;
  figureName: string;
}

type ResponseTextPos = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};

export default class SpecResponseAnnotation extends Component<SpecResponseArgs> {
  get responseTextPos(): ResponseTextPos {
    let x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0;
    const position = this.getResponsePosition();
    switch (position) {
      case Position.LEFT:
        x1 = x2 = 10;
        y1 = this.args.geometry.height - 30;
        y2 = this.args.geometry.height - 10;
        break;
      case Position.RIGHT:
        x1 = x2 = this.args.geometry.width - 200;
        y1 = this.args.geometry.height - 30;
        y2 = this.args.geometry.height - 10;
        break;
      case Position.CENTER:
        x1 = x2 = Math.round(this.args.geometry.width / 2) - 80;
        y1 = this.args.geometry.height - 30;
        y2 = this.args.geometry.height - 10;
        break;
    }
    return { x1: x1, y1: y1, x2: x2, y2: y2 };
  }

  get isChebyshevFilterResponse(): boolean {
    return this.args.model.responseType === FilterConstants.responseType.chebyshev;
  }

  // Determines the Position of the Response Text based on the Filter Type and Graph Type
  // Returns: responsePosition - Values can either be "Left", "Center" or "Right"
  getResponsePosition(): string {
    const filterType = this.args.model.filterName;
    const figureName = this.args.figureName;
    let responsePosition = '';

    switch (figureName) {
      case FilterConstants.figureName.magnitudeDb:
      case FilterConstants.figureName.magnitudeVV:
        switch (filterType) {
          case FilterConstants.filterType.highPass:
            responsePosition = Position.RIGHT;
            break;
          case FilterConstants.filterType.bandPass:
            responsePosition = Position.CENTER;
            break;
          case FilterConstants.filterType.lowPass:
          default:
            responsePosition = Position.LEFT;
            break;
        }
        break;
      case FilterConstants.figureName.phaseDegrees:
      case FilterConstants.figureName.phaseRadians:
        responsePosition = Position.LEFT;
        break;
      case FilterConstants.figureName.phaseDelay:
      case FilterConstants.figureName.groupDelay:
        switch (filterType) {
          case FilterConstants.filterType.bandPass:
            responsePosition = Position.CENTER;
            break;
          case FilterConstants.filterType.highPass:
          case FilterConstants.filterType.lowPass:
          default:
            responsePosition = Position.LEFT;
            break;
        }
        break;
      case FilterConstants.figureName.stepResponse:
        responsePosition = Position.RIGHT;
        break;
    }

    return responsePosition;
  }
}
